export interface RegulatoryFormLink {
  title: string;
  href: string;
}

export interface RegulatoryFormItem {
  title: string;
  type: "single" | "multiple";
  href?: string;
  forms?: RegulatoryFormLink[];
}

export const regulatoryFormsData: RegulatoryFormItem[] = [
  {
    title: "Georgia COAM Information",
    type: "single",
    href: "https://www.playgeorgia.com/coin-operated-amusement-machines/",
  },
  {
    title: "COAM Reporting",
    type: "single",
    href: "https://www.gacoam.com/API/Documents/Document?documentID=151",
  },
  {
    title: "COAM Restrictions",
    type: "single",
    href: "https://www.playusa.com/news/georgia-coin-machines-restrictions/",
  },
  {
    title: "COAM Central Accounting System Info",
    type: "multiple",
    forms: [
      {
        title: "Equipment Management Instructions",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=1",
      },
    ],
  },
  {
    title: "COAM Laws, Rules, & Regulations",
    type: "multiple",
    forms: [
      {
        title: "RUI3.1 – Coin Operated Amusement Machine Administration",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=254",
      },
      {
        title: "RUI3.2 – Coin Operated Amusement Machine Hearing",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=255",
      },
      {
        title:
          "RUI3.3 – Coin Operated Amusement Machines: Lottery Tickets as Prizes",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=256",
      },
      {
        title: "RUI3.4 – Regulatory Enhancements: Discussion Points",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=192",
      },
      {
        title: "Relevant Provisions of the Georgia Criminal Code",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=459",
      },
      {
        title: "Definition of Existing and Legacy COAMs",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=50",
      },
      {
        title: "Secured Compartment",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=47",
      },
      {
        title: "SAS Requirements (Version 1.7)",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=125",
      },
      {
        title: "COAM Law – May 8, 2018",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=258",
      },
    ],
  },
  {
    title: "COAM Communications",
    type: "multiple",
    forms: [
      {
        title: "Gift Card Pilot Program Extension – Frequently Asked Questions",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=477",
      },
      {
        title: "Gross Retail Receipts Rule",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=462",
      },
      {
        title: "COAM Newsletter",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=460",
      },
      {
        title:
          "Class B APPLIED Location License Holder List for 2023 (as of 09/28/22)",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=524",
      },
      {
        title:
          "Class B APPROVED Location and Master License Holder List for 2023 (as of 09/28/22)",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=528",
      },
      {
        title:
          "Approved Manufacturer and Distributor License Holder List for 2023 (as of 09/28/22)",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=527",
      },
      {
        title: "Location License Holder Guide – Version 1.02",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=410",
      },
      {
        title: "COAM Financial Sweep and Push Calendar for 2022",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=467",
      },
      {
        title: "Important Message Sign – Updated 04/14/2020",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=320",
      },
      {
        title: "Frequently Asked Questions for Locations",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=196",
      },
      {
        title: "Financial Security Deposit (FSD) Guidelines",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=301",
      },
      {
        title: "Decommission Procedures",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=228",
      },
      {
        title: "COAM Notice – Submission of Forms",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=113",
      },
      {
        title: "COAM Hard Reset Procedures for MLH",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=108",
      },
      {
        title: "COAM Regulatory and Licensing Information Video",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=95",
      },
      {
        title: "Fish Game Notice",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=81",
      },
      {
        title: "Responsible Gaming",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=66",
      },
      {
        title: "Master Portal User Guide",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=62",
      },
      {
        title: "Location Portal User Guide",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=64",
      },
      {
        title: "Manufacturer Portal User Guide",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=193",
      },
      {
        title: "Class A and Class B Reminder Notice",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=46",
      },
      {
        title:
          "Important Enforcement and Compliance Notice for all COAM Licensees",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=7",
      },
      {
        title: "Central System Connection Notice",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=54",
      },
    ],
  },
  {
    title: "COAM Forms",
    type: "multiple",
    forms: [
      {
        title: "1099-MISC Request Form",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=304",
      },
      {
        title: "Letter of Resignation",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=300",
      },
      {
        title: "Decommission Procedures Quick Reference Guide",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=249",
      },
      {
        title: "Grant Access Form",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=495",
      },
      {
        title: "EFT Form for Location License Holders",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=305",
      },
      {
        title: "EFT Form for Master License Holders",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=306",
      },
      {
        title: "50% Gross Calculation Worksheet For Licensees 2020",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=287",
      },
      {
        title: "COAM License Cancellation Request Form",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=312",
      },
      {
        title: "Change of Master to Place COAMs Form",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=468",
      },
      {
        title: "Arbitration Form",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=404",
      },
      {
        title: "Master Dispute Certification Form",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=117",
      },
      {
        title: "Play Responsibly Sign",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=222",
      },
      {
        title: "Verification of Lawful Presence Affidavit",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=43",
      },
      {
        title: "Affidavit Instructions",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=42",
      },
      {
        title: "COAM Master Licensee Affidavit",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=22",
      },
      {
        title: "Master Class B License Instructions",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=24",
      },
      {
        title: "Fraud, Abuse, or Cash Payouts Sign",
        href: "https://www.gacoam.com/API/Documents/Document?documentID=106",
      },
    ],
  },
];
